import { render, staticRenderFns } from "./body-content.vue?vue&type=template&id=10d12698&"
import script from "./body-content.vue?vue&type=script&lang=js&"
export * from "./body-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('10d12698', component.options)
    } else {
      api.reload('10d12698', component.options)
    }
    module.hot.accept("./body-content.vue?vue&type=template&id=10d12698&", function () {
      api.rerender('10d12698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/layout/body-content.vue"
export default component.exports